import { render, staticRenderFns } from "./ArchiveProjectDialog.vue?vue&type=template&id=f2c8338a&"
import script from "./ArchiveProjectDialog.vue?vue&type=script&lang=js&"
export * from "./ArchiveProjectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports